import {Button} from "primereact/button";
import React from "react";
import {useLogoutMutation} from "../../apis/authenticationApi";
import {useNavigate} from "react-router-dom";

const LogoutButton = () => {
    const [logout] = useLogoutMutation();
    const navigate = useNavigate();
    const onLogout = async () => {
        await logout();

        navigate('/auth/login');
    }
    return (
        <Button label="Logout" onClick={() => onLogout()} />
    )
}

export default LogoutButton;